import { createPatchEndpoint } from '@sonar-software/sonar-http';
import { SonarTag } from '@types';

export type PatchTagRequest = Omit<SonarTag, 'autoTagged'>;

export const patchTag = createPatchEndpoint<PatchTagRequest>(
	(request) => `/api/v3/core/tags/${request.id}`, {
		requestTransform: (request) => ({
			...request,
			sonarObjectTagId: request.id
		})
	}
);
